import { Service } from '@phishtool/service';
import getKnowledgeBaseArticleController from '~controllers/service/knowledge-base-article';
export class KnowledgeBaseArticleService extends Service {
    constructor() {
        super(...arguments);
        this.useGetKnowledgeBaseArticle = this.addSingletonQuery({
            controller: getKnowledgeBaseArticleController,
            opts: {
                staleTime: Infinity,
            },
        });
    }
}
